module.exports = __webpack_public_path__ + "static/media/V-img4.c25ee510.png";